import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ApplicationList } from '../../../communication-structure/application-list';
import { AutoTrainingCodeModel } from '../../../communication-structure/auto-training-code-model';
import { CandidateModel, ResendModel } from '../../../communication-structure/new-candidate-model';
import { SendEmailModel } from '../../../communication-structure/send-email-model';
import { CommunicationProxyService } from '../../../services/communication-proxy.service';
import { LoginService } from '../../../services/login.service';
import { StringTableService } from '../../../services/string-table.service';
import { PageViewComponent } from '../../page-view/page-view.component';
import { Table, Types } from '../../table/table.component';
import { ButtonModel } from '../../tg-button/tg-button.component';
import { ATCTYPE } from '../email-invite/email-invite.component';
import { activeTrainingPageEnum, TrainingManagementComponent } from '../training-management/training-management.component';
import { TextareaComponent } from '../../textarea/textarea.component';

@Component({
  selector: 'app-email-sent',
  templateUrl: './email-sent.component.html',
  styleUrls: ['./email-sent.component.scss']
})
export class EmailSentComponent extends PageViewComponent implements OnInit {

  public pageTitle: string;
  public pageDesc: string;
  public textAreaTitle: string;
  public textAreaPlaceholder: string;
  public emailTextKeywordsTitle: string;
  public emailTextKeywordsText: string;
  public selectTitle: string;
  public startDateTitle: string;
  public endDateTitle: string;
  public filterDropdownTitle: string;
  public dropdownPlaceholder: string;
  public testSessionLink: string;
  public emailSentTitle: string;
  public emailSentDesc: string;
  public noDataText: string;
  public noSelectionText: string;
  popupState = false;
  applicationList: Array<ApplicationList>;
  getClientATCListEndPoint: string;
  getApplicationWithEmailEndPoint: string;
  trainingData: Array<AutoTrainingCodeModel>;
  dropdownData: Array<{ id: string, name: string }>;
  header: Table[];
  displayedTable: Table[][];
  fullTable: Table[][];
  dateFilteredTable: Table[][] = null;
  atcSelected: string = null;
  atcName: string;
  filterOptions: Array<{ id: number, name: string }>;
  sendMailToApplicationsEndPoint: string;
  resendMailToApplicantEndPoint: string;
  mailText = "";

  public btnData: ButtonModel = { name: '', icon: '' };

  // boolean to distinguish between email-sent & reporting component
  isReporting = false;

  isExtendedTable: boolean;

  private startDate: { date: Date, isDateValid: boolean } = { date: null, isDateValid: false };
  private endDate: { date: Date, isDateValid: boolean } = { date: null, isDateValid: false };
  isStartDateValid: boolean;
  isEndDateValid: boolean;
  private formattedStartDate: Date;
  private formattedEndDate: Date;

  @ViewChild('SelectTraining') selectTrainingDropdown;
  @ViewChild('StatusDropdown') statusDropdown;
  @ViewChild('detailsTable') detailsTable;
  @ViewChild('startDate') startDateBox;
  @ViewChild('endDate') endDateBox;
  @ViewChild('resendEmailBody') textArea;
  

  constructor(ele: ElementRef,
    remoteProxy: CommunicationProxyService,
    protected loginService: LoginService,
    stringTableService: StringTableService,
    protected router: Router,
    protected cdr: ChangeDetectorRef) {
    super(ele, remoteProxy, loginService, stringTableService, router);
    this.retrieveStrings();
  }

  ngOnInit() {
    TrainingManagementComponent.setActiveTrainingPage(activeTrainingPageEnum.emailSent);
    this.createHeader();
    this.getClientAtcList(ATCTYPE.ACTIVE);
    this.selectTrainingDropdown.setFocus();
  }

  retrieveStrings() {
    this.pageTitle = this.stringTableService.getString('emailsSent', 'pageTitle');
    this.pageDesc = this.stringTableService.getString('emailsSent', 'pageDesc');
    this.textAreaTitle = this.stringTableService.getString('emailsSent', 'textAreaTitle');
    this.textAreaPlaceholder = this.stringTableService.getString('emailsSent', 'textAreaPlaceholder');
    this.emailTextKeywordsTitle = this.stringTableService.getString('emailsSent', 'emailTextKeywordsTitle');
    this.emailTextKeywordsText = this.stringTableService.getString('emailsSent', 'emailTextKeywordsText');
    this.mailText = this.stringTableService.getString('emailsSent', 'mailText');
    this.selectTitle = this.stringTableService.getString('emailsSent', 'selectTitle');
    this.startDateTitle = this.stringTableService.getString('createAutoTrainingCode', 'startDateTitle');
    this.endDateTitle = this.stringTableService.getString('createAutoTrainingCode', 'endDateTitle');
    this.filterDropdownTitle = this.stringTableService.getString('emailsSent', 'filterDropdownTitle');
    this.dropdownPlaceholder = this.stringTableService.getString('labels', 'all');
    this.getClientATCListEndPoint = this.stringTableService.getEndpoint('GetClientATCList');
    this.getApplicationWithEmailEndPoint = this.stringTableService.getEndpoint('GetAllApplicationWithSentEmailForAtc');
    this.emailSentTitle = this.stringTableService.getString('emailInvite', 'emailSentTitle');
    this.emailSentDesc = this.stringTableService.getString('emailInvite', 'emailSentDesc');
    this.noDataText = this.stringTableService.getString('emailsSent', 'noData');
    this.noSelectionText = this.stringTableService.getString('emailsSent', 'noSelection');
    this.filterOptions = [{ id: 0, name: this.stringTableService.getString('labels', 'all') },
    { id: 1, name: this.stringTableService.getString('labels', 'completed') },
    { id: 2, name: this.stringTableService.getString('labels', 'incomplete') }];

    this.btnData = {
      name: this.stringTableService.getString('emailsSent', 'btnTitle'),
      icon: this.stringTableService.getString('icons', 'forward')
    };
    this.sendMailToApplicationsEndPoint = this.stringTableService.getEndpoint('SendMailToApplications');
    this.resendMailToApplicantEndPoint = this.stringTableService.getEndpoint('ResendMailToApplicant');
  }

  createHeader() {
    this.header = [
      new Table(Types.CHECK_BOX, 'table-header', ''),
      new Table(Types.TEXT, 'table-header', this.stringTableService.getString('labels', 'firstName')),
      new Table(Types.TEXT, 'table-header', this.stringTableService.getString('labels', 'lastName')),
      new Table(Types.TEXT, 'table-header', this.stringTableService.getString('labels', 'email')),
      new Table(Types.TEXT, 'table-header', this.stringTableService.getString('emailsSent', 'trainingLink')),
      new Table(Types.TEXT, 'table-header', this.stringTableService.getString('emailsSent', 'dateSent')),
      new Table(Types.TEXT, 'table-header', this.stringTableService.getString('emailsSent', 'dateComplete'))
    ];
  }

  /**
   *
   * @param activeStatus the type of ATC list which we want to fetch 0 - inactive, 1 - active, 2 - both
   */
  getClientAtcList(activeStatus) {
    this.getDataFromApi(this.getClientATCListEndPoint, { clientId: this.currentUserClientID, active: activeStatus })
      .subscribe(this.handleClientAtcListData.bind(this),
      this.handleSubscriptionError.bind(this, this.getClientAtcList.bind(this, activeStatus), false));
  }

  /**
   * create table using response
   * @param data response from server
   */
  handleClientAtcListData(data) {
    this.hideLoader();
    this.trainingData = data.autoTrainingCodeList;
    this.dropdownData = [];

    for (const record of this.trainingData) {
      this.dropdownData.push({ id: record.autoTrainingCodeId, name: record.autoTrainingCodeName });
    }
  }

  /**
   *
   * @param data info about the ATC selected in dropdown
   */
  onMenuItemChange(data) {
    this.getClientApplicationWithScore(data.id);
    this.testSessionLink = 'testlink.com/sample';
    this.atcSelected = data.id;
    this.atcName = data.name;
  }

  getClientApplicationWithScore(atcId) {
    this.getDataFromApi(this.getApplicationWithEmailEndPoint, { clientId: this.currentUserClientID, autoTestCodeId: atcId })
      .subscribe(this.handleClientApplicationEmail.bind(this),
      this.handleSubscriptionError.bind(this, this.getClientApplicationWithScore.bind(this, atcId), false));
  }

  handleClientApplicationEmail(data) {
    this.hideLoader();
    this.fullTable = [];
    this.applicationList = data.applicationList;
    for (let count = 0; count < this.applicationList.length; count++) {
      const currentCandidate = this.applicationList[count];

      const isComplete = this.applicationList[count].completedDate !== '' && this.applicationList[count].completedDate !== null;
      const tableClass = isComplete ? STATUS_CLASS.COMPLETED : STATUS_CLASS.INCOMPLETE;
      const tableRow = [
        new Table(Types.CHECK_BOX, tableClass, ''),
        new Table(Types.TEXT, tableClass, currentCandidate.candidateName.split(' ')[0]),
        new Table(Types.TEXT, tableClass, currentCandidate.candidateName.split(' ')[1]),
        new Table(Types.TEXT, tableClass, currentCandidate.candidateEmail),
        isComplete ? new Table(Types.TEXT, tableClass, 'Complete') :
          new Table(Types.LINK, tableClass, currentCandidate.trainingSessionLink),
        new Table(Types.DATE, tableClass, this.formatDate(this.dateConversion(currentCandidate.sentDate))),
        new Table(Types.DATE, tableClass, this.formatDate(this.dateConversion(currentCandidate.completedDate)))
      ];
      this.fullTable.push(tableRow);
      this.displayedTable = this.fullTable;
      this.cdr.detectChanges();
    }
    this.isExtendedTable = this.fullTable.length > 10;
    this.filterDataUsingDate();
  }

  onStartDateChanged(event) {
    this.startDate = this.getDateData(event);
    this.formattedStartDate = this.startDate.isDateValid ? this.changeDPDateFormat(this.startDate.date) : null;
    if(this.endDate.isDateValid) {
      this.filterDataUsingDate();
    }
  }

  onEndDateChanged(event) {
    this.endDate = this.getDateData(event);
    this.formattedEndDate = this.endDate.isDateValid ? this.changeDPDateFormat(this.endDate.date) : null;
    if(this.startDate.isDateValid) {
      this.filterDataUsingDate();
    }
  }

  filterCheckboxes() {
    this.cdr.detectChanges();
    let anySelected = false;

    if (this.detailsTable !== undefined) {
      const checkBoxes = this.detailsTable.getCheckboxes();
      this.displayedTable.forEach((currRow, index) => {
        const isComplete = currRow[0].strClass === STATUS_CLASS.COMPLETED;
        if (isComplete) {
          checkBoxes[index].isEnable = false;
        }
      });

      checkBoxes.forEach(checkBox => {
        if (checkBox.isSelected) {
          anySelected = true;
        }
      });

      if (!anySelected) {
        this.detailsTable.headerCheckbox.isSelected = false;
      }
    }
  }

  /**
   * Filter data using start and end dates
   */
  filterDataUsingDate() {
    if ((this.fullTable && this.fullTable.length) && (this.startDate.isDateValid || this.endDate.isDateValid)) {
      if (this.dateValidation(this.startDate, this.endDate)) {
        this.dateFilteredTable = [];
        for (const record of this.fullTable) {
          const completedDate = this.dateConversion(record[6].title);
          if (completedDate) {
            completedDate.setHours(0, 0, 0, 0);
          }

          const sentDate = this.dateConversion(record[5].title);
          sentDate.setHours(0, 0, 0, 0);

          if (completedDate && completedDate >= this.formattedStartDate && completedDate <= this.formattedEndDate) {
            this.dateFilteredTable.push(record);
          } else if (this.formattedStartDate != null && this.formattedEndDate == null) {
            if (sentDate >= this.formattedStartDate) {
              this.dateFilteredTable.push(record);
            }
          } else if (this.formattedStartDate == null && this.formattedEndDate != null) {
            if (completedDate && completedDate <= this.formattedEndDate) {
              this.dateFilteredTable.push(record);
            }
          } else if(this.formattedStartDate && this.formattedEndDate){
            if((sentDate && sentDate >= this.formattedStartDate && sentDate <= this.formattedEndDate) || 
                (completedDate && completedDate >= this.formattedStartDate && completedDate <= this.formattedEndDate)) {
              this.dateFilteredTable.push(record);
            } 
          }
        }
        this.displayedTable = this.dateFilteredTable;
      } else {
        this.clearDates();
      }
    } else {
      this.dateFilteredTable = null;
      this.displayedTable = this.fullTable;
    }
    this.filterDataWithStatus(this.statusDropdown.selectedIndex);
  }

  clearDates() {
    this.startDate = this.endDate = { date: null, isDateValid: false };
    this.startDateBox.datePicker.clearDate();
    this.endDateBox.datePicker.clearDate();
  }

  /**
   * Set selected index of dropdown
   * @param event contains id and text of selected option
   */
  statusFilterChanged(event) {
    this.statusDropdown.selectedIndex = event.id;
    this.filterDataWithStatus(this.statusDropdown.selectedIndex);
  }

  /**
   * Filter data according to status selected in dropdown
   * @param statusId id of selected option
   */
  filterDataWithStatus(statusId: number) {
    if (!this.fullTable) {
      return;
    }

    switch (statusId) {
      case 0:
      case -1:
        this.displayedTable = this.dateFilteredTable ? this.dateFilteredTable : this.fullTable;
        break;
      case 1:
        this.filterDataUsingClass(STATUS_CLASS.COMPLETED);
        break;
      case 2:
        this.filterDataUsingClass(STATUS_CLASS.INCOMPLETE);
        break;
    }
    this.filterCheckboxes();
  }

  /**
   * Filter data using class applied to data
   * @param className class applied if training completed or not
   */
  filterDataUsingClass(className: string) {
    this.displayedTable = this.dateFilteredTable ? this.dateFilteredTable : this.fullTable;
    const filteredTable = [];
    this.displayedTable.forEach((currentCandidate) => {
      if (currentCandidate[0].strClass === className) {
        filteredTable.push(currentCandidate);
      }
    });
    this.displayedTable = filteredTable;
  }

  onResendEmail() {
    const checkBoxes = this.detailsTable.getCheckboxes();
    const resendList: ResendModel[] = [];

    checkBoxes.forEach((checkBox, index) => {
      if (checkBox.isSelected) {
        resendList.push({
          applicationId: this.applicationList[index].applicationId,
          emailText: this.textArea.getBypassSecurityTrustHtml()
        });
      }
    });


    if (!resendList.length) {
      this.showValidationPopup(this.noDataText, this.noSelectionText);
    } else {
        const dataToBeSent: ResendModel = {
          applicationId: null,
          emailText: null
          };

      for (const applicant of resendList) {
        dataToBeSent.applicationId = applicant.applicationId;
        dataToBeSent.emailText = applicant.emailText;
        this.postDataToApi(this.resendMailToApplicantEndPoint, dataToBeSent)
          .subscribe(
          this.onEmailResendSuccess.bind(this),
          this.handleSubscriptionError.bind(this, this.onResendEmail.bind(this), true)
          );
      }
    }

  }

  onEmailResendSuccess() {
    this.hideLoader();
    this.resetSelections();
    this.showValidationPopup(this.emailSentTitle, this.emailSentDesc);
  }

  resetSelections() {
    const checkBoxes = this.detailsTable.getCheckboxes();

    checkBoxes.forEach(checkBox => {
      checkBox.isSelected = false;
    });
    this.detailsTable.headerCheckbox.isSelected = false;
  }

  showValidationPopup(title, bodyText) {
    const dataForDialog = {
      title: title,
      body: bodyText
    };
    this.validationPopup = true;
    this.showDialog(dataForDialog, () => { this.validationPopup = false; });
  }
}

enum STATUSLIST {
  ALL = 0,
  COMPLETED = 1,
  INCOMPLETE = 2
}

export enum STATUS_CLASS {
  COMPLETED = 'table-data-complete',
  INCOMPLETE = 'table-data-incomplete'
}




// WEBPACK FOOTER //
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/training-management/email-sent/email-sent.component.ts